import React from 'react';
import { useCardContext } from "../contexts/CardContext";
import TicketDetails from "./TicketDetails";

export default function CardActions() {
    const { cardNumber, tickets, setCardNumber, setTickets, loading } = useCardContext();

    const handleReset = () => {
        localStorage.removeItem('cardNumber');
        localStorage.removeItem('tickets');
        setCardNumber('');
        setTickets([]);
    };

    const handleRefresh = () => {
        if (cardNumber) {
            const url = `https://epass.easypay.ua/api/customer/${cardNumber}/tickets`;
            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                    const fetchedTickets = data.results || data;
                    if (Array.isArray(fetchedTickets)) {
                        setTickets(fetchedTickets);
                    } else {
                        setTickets([]);
                    }
                })
                .catch(error => {
                    console.error('Помилка отримання тікетів:', error);
                    setTickets([]);
                });
        }
    };

    const styles = {
        container: {
            maxWidth: '1280px',
            margin: '0 auto',
            padding: '20px',
            backgroundColor: '#f9f9f9',
            border: '1px solid #ddd',
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
        },
        logo: {
            margin: '20px',
            width: '200px',
            alignSelf: 'center',
        },
        header: {
            position: 'sticky',
            top: 0,
            backgroundColor: '#f9f9f9',
            zIndex: 1,
            paddingBottom: '10px',
            borderBottom: '1px solid #ddd',
        },
        title: {
            fontSize: '24px',
            marginBottom: '10px',
            textAlign: 'center',
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            marginBottom: '20px',
        },
        button: {
            padding: '10px 15px',
            fontSize: '16px',
            backgroundColor: '#1f83fe',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
        },
        ticketListContainer: {
            flex: 1,
            overflowY: 'auto',
            paddingTop: '20px',
        },
        ticketList: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '20px',
        },
    };

    return (
        <div style={styles.container}>
            <img src="./logo_v2.png" alt="epass Logo" style={styles.logo} />
            <div style={styles.header}>
                <h2 style={styles.title}>Квитки для карти {cardNumber}</h2>
                <div style={styles.buttonContainer}>
                    <button style={styles.button} onClick={handleReset}>Інша картка</button>
                    <button style={styles.button} onClick={handleRefresh}>Оновити</button>
                </div>
            </div>
            <div style={styles.ticketListContainer}>
                {loading ? (
                    <p>Завантаження квитків...</p>
                ) : (
                    tickets && tickets.length > 0 ? (
                        <div style={styles.ticketList}>
                            {tickets.map((ticket, index) => (
                                <TicketDetails key={index} ticket={ticket} />
                            ))}
                        </div>
                    ) : (
                        <p>Квитки відсутні.</p>
                    )
                )}
            </div>
        </div>
    );
}